import { Grid, DiceValue, Column } from '../types';

export const calculateColumnScore = (column: Column): number => {
  const counts: Record<number, number> = {};
  column.forEach(val => {
    if (val) counts[val] = (counts[val] || 0) + 1;
  });

  let score = 0;
  Object.entries(counts).forEach(([val, count]) => {
    const value = parseInt(val);
    score += value * count * count;
  });
  return score;
};

export const calculateTotalScore = (grid: Grid): number => {
  return grid.reduce((acc, col) => acc + calculateColumnScore(col), 0);
};

export const isGridFull = (grid: Grid): boolean => {
  return grid.every(col => col.filter(v => v !== null).length === 3);
};

export const getAvailableColumns = (grid: Grid): number[] => {
  return grid
    .map((col, idx) => (col.filter(v => v !== null).length < 3 ? idx : -1))
    .filter(idx => idx !== -1);
};
